import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { readLocal, writeLocal } from '../../core/storage';
import { useHasUnsavedWork } from '../../contexts/UnsavedWorkContext';
import { ACTIVITY_KEY, ACTIVITY_WRITE_MS, idleDecision, lastActivity } from './idle';
const EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const;
const CHECK_MS = 60_000;

/**
 * Logt uit na 30 minuten zonder activiteit in alle beheer-tabbladen samen, behalve als er
 * niet-opgeslagen werk openstaat. Rendert niets. Staat binnen het register van open werk.
 */
export function IdleLogout({
  onLogout
}: {
  onLogout: () => void;
}) {
  const hasWork = useHasUnsavedWork();
  const hasWorkRef = useRef(hasWork);
  hasWorkRef.current = hasWork;
  const logoutRef = useRef(onLogout);
  logoutRef.current = onLogout;
  useEffect(() => {
    let local = Date.now();
    let written = 0;
    const mark = () => {
      local = Date.now();
      if (local - written > ACTIVITY_WRITE_MS) {
        written = local;
        writeLocal(ACTIVITY_KEY, String(local));
      }
    };
    mark();
    const check = () => {
      if (idleDecision(Date.now(), lastActivity(local, readLocal(ACTIVITY_KEY)), hasWorkRef.current) !== 'logout') return;
      toast('Je bent uitgelogd', {
        description: 'Na 30 minuten zonder activiteit, voor de veiligheid van klantgegevens.'
      });
      logoutRef.current();
    };
    EVENTS.forEach(e => window.addEventListener(e, mark, {
      passive: true
    }));
    // Terug naar het tabblad na een lange pauze: meteen controleren, niet pas bij de volgende ronde.
    const onVisible = () => document.visibilityState === 'visible' && check();
    document.addEventListener('visibilitychange', onVisible);
    const timer = window.setInterval(check, CHECK_MS);
    return () => {
      EVENTS.forEach(e => window.removeEventListener(e, mark));
      document.removeEventListener('visibilitychange', onVisible);
      window.clearInterval(timer);
    };
  }, []);
  return null;
}